 import React from 'react';
 
 import ethImg from '../../assets/ethereum.png';
 
 import './ProposeBurn.css';
 
 function ProposeBurn(props) {
 
     return (
         <div className="ghost-propose-burn-container">
             <div className="ghost-propose-burn-used">
                 <div className="ghost-propose-burn-used-network">
                     <img src={ethImg} alt="ethereum"></img>
                     <span>{props.network}</span>
                 </div>
                 <div className="ghost-propose-burn-used-asset">
                     <img src={ethImg} alt="ethereum"></img>
                     <span className="ghost-propose-burn-used-asset-ticker">{props.asset}</span>
                     <span className="ghost-propose-burn-used-asset-name">{props.assetName}</span>
                 </div>
             </div>
 
             <div className="ghost-propose-burn-used-slider-container">
                 <input type="range" min="1" max="100" value={props.rangeValue} onChange={(event) => props.handleRangeChange(event)}     className="ghost-propose-burn-used-slider" id="myRange" />
                 <div className="ghost-propose-burn-used-slider-value">
                     <span>{props.rangeValue}</span>
                     <span>{props.asset}</span>
                 </div>
             </div>
 
             <div className="ghost-propose-burn-buttons">
                 <div onClick={() => props.setStep(props.step-1)} className="ghost-propose-burn-buttons-button">Previous Step</div>
                 <div onClick={() => alert("tx sent")} className="ghost-propose-burn-buttons-button">Transfer</div>
             </div>
         </div>
     )
 }
 
 export default ProposeBurn;
